import Slide, { SlideProps } from '@mui/material/Slide';

export default function TransitionRight(props: SlideProps) {
  return (
    <Slide {...props} direction="right">
      {props.children}
    </Slide>
  );
}
